import Flickity from "flickity";
import flickityFade from "flickity-fade";
import gsap from "gsap";
// works with  1 area in the center - review below 


export function bgViewer(bgViewer) {
  // in this function we intiate flickiyt

  /*
  1. we need to ensure we can filter views - change the active links 
  // the would be functions that are called via the home ui - so how do we integrate that neatly?

  2. this bgViewer function is running on each/ every page?

  3. as we have some sort of screensaver - where does that get called? - probably in the detect position script

  4.what if on different pages I want to have different bg's? - we need to be able to filter the bg's - and also the side links
  + that content might be different on each page - so how to append or re-init based on dom changes

  5. consider image loaded and also only load and show this content after the rest of the page has loaded
  // review how to defer or approoach this
  */

  // Initiate flickity with fade effect


  // console.log("bgViewer", bgViewer, "is loading");


  var carousel = bgViewer.querySelector('.bg-viewer__container');
  var details = bgViewer.querySelector('.bg-viewer__details');
  var flkty;
  var isResizing = false;

  flkty = new Flickity(carousel, {
    // Flickity options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    setGallerySize: false,
    // selectedAttraction: 0.001, // attempting to slow down the slide fading massively!
    // friction: 0, // attempting to slow down the slide fading massively!
    pageDots: false, // built custom ui for this
    // autoPlay: true,
    autoPlay: 7500,
    // Custom fade effect
    fade: true,
    on: {
      // Custom function to handle fade in/out
      ready: function () {
        // console.log(" ready: function () {");
      },
      change: function () {
        // console.log("flkty change: function ()");
      },
      select: function (index) {
        // console.log("flkty.selectedIndex - Update the slider details", index);
        updateBgViewer(carousel, details, index);
      },
      resize: function () {
        if (!isResizing) {
          isResizing = true;
          // console.log("flkty resize: function ()");
          // Reload cells and then resize
          flkty.reloadCells();
          flkty.resize();
          // flkty.resize();
          isResizing = false;
        }
      }
    }
  });


  // start the timer
  timerBgViewer(carousel);

}

export function updateBgViewer(carousel, details, index) {
//  console.log("updateBgViewer", carousel, details, index);

  var activeSlideId = carousel.querySelector('.is-selected').getAttribute('data-item-id'),
    activeDetailsItem = details.querySelector('.bg-viewer__item[data-item-id="' + activeSlideId + '"]'),
    allDetailsItems = details.querySelectorAll('.bg-viewer__item'),
  // Calculate index of next and previous items
    nextIndex = (index + 1) % allDetailsItems.length,
    prevIndex = (index - 1 + allDetailsItems.length) % allDetailsItems.length;


  requestAnimationFrame(() => {

    // Update the active details item
    allDetailsItems.forEach(item => {
      item.classList.remove('is-selected', 'is-next', 'is-previous');
    });

    activeDetailsItem.classList.add('is-selected');
    //Add classes to next and previous items
    allDetailsItems[nextIndex].classList.add('is-next');
    allDetailsItems[prevIndex].classList.add('is-previous');
  });
}



// export function updateBgViewer(carousel, details, index) {
//   var activeSlideId = carousel.querySelector('.is-selected').getAttribute('data-item-id'),
//       activeDetailsItem = details.querySelector('.bg-viewer__item[data-item-id="' + activeSlideId + '"]'),
//       allDetailsItems = details.querySelectorAll('.bg-viewer__item');

//   // Update the active details item with requestAnimationFrame
//   requestAnimationFrame(() => {
//     allDetailsItems.forEach(item => {
//       item.classList.remove( 'is-next', 'is-previous');
//     });

//     activeDetailsItem.classList.add('is-selected');

//   });

//   // Calculate index of next and previous items
//   var nextIndex = (index + 1) % allDetailsItems.length;
//   var prevIndex = (index - 1 + allDetailsItems.length) % allDetailsItems.length;

//   // Add classes to next and previous items with requestAnimationFrame
//   requestAnimationFrame(() => {
//     allDetailsItems[nextIndex].classList.add('is-next');
//   });

//   requestAnimationFrame(() => {
//     allDetailsItems[prevIndex].classList.add('is-previous');
//     setTimeout(() => {
//       //wait for a bit then remove the selected; from the is-previous
//       allDetailsItems[prevIndex].classList.remove('is-selected'); // remove the active class here

//     }, 40); // Adjust the delay as needed

//   });
// }


export function timerBgViewer(carousel) {

var idleTimeout;
var idleTime;
var body = document.body;
var bgViewer = document.querySelector('#bg-viewer');

if (carousel.getAttribute('data-timer')) {
  idleTime = carousel.getAttribute('data-timer');
 // needs to be in miliseconds value is in seconds
  idleTime = idleTime * 1000;
} else {
  // idleTime = 30000; // 30 seconds -- default/fallback
  // idleTime = 60000; // 60 seconds -- default/fallback -- review this - ensure its long enough for RS not to flag as issue
  // idleTime = 120000; // 120 seconds -- default/fallback -- review this - ensure its long enough for RS not to flag as issue
  idleTime = 240000; // 240 seconds  

}

function handleUserActivity() {
    body.classList.remove('viewer-active');
    clearTimeout(idleTimeout);

    idleTimeout = setTimeout(function () {
        body.classList.add('viewer-active');
        console.log('screensaver active - which means we need to ensrue full opacity of the bg-viewer - review here')
        bgViewer.style.opacity = 1;
        //end review - dlete comments etc if the bg viewew is always full opacity when active
    }, idleTime);
}

function handleLinkClick() {
    body.classList.remove('viewer-active');
}

function handleTouchStart() {
    handleUserActivity();
}

function initializeScreensaver() {
    document.addEventListener('mousemove', handleUserActivity);
    document.addEventListener('touchmove', handleTouchStart);
    // document.addEventListener('click', handleLinkClick);
}
// If I temporarily disable this - with a view to maybe back in later?
// initializeScreensaver();
}
